import React from 'react';
import { SectionLabel } from './SectionLabel';
import { CtaButton } from './CtaButton';
export function FinalThoughts() {
  return <section className="w-full bg-cream" aria-labelledby="final-heading" data-id="element-112" data-mp="2exn7irjr61j8">
      <div className="mx-auto max-w-readable px-4 py-14 text-center sm:px-5 sm:py-24" data-id="element-113" data-mp="2sptf3p8ub072">
        <SectionLabel align="center" data-id="element-114" data-mp="2ong9r1y094at">Final thoughts</SectionLabel>

        <h2 id="final-heading" className="mt-5 font-display text-[2rem] font-semibold leading-[1.05] tracking-[-0.02em] text-ink sm:mt-6 sm:text-6xl" data-id="element-115" data-mp="2oqc6imy49mxo">
          Stop the stress.{' '}
          <span className="italic text-terracotta" data-id="element-116" data-mp="29z23eh1dqxpi">Start the training.</span>
        </h2>

        <p className="mt-6 text-[15px] leading-relaxed text-ink/75 sm:mt-8 sm:text-lg" data-id="element-117" data-mp="24zz0b24yn1k6">
          Don’t spend another day frustrated with your dog’s behavior. In 30
          days, you could have the calm, obedient companion you always dreamed
          of… or you could be in the exact same spot you are today.
        </p>

        <p className="mt-4 text-[15px] leading-relaxed text-ink/75 sm:mt-5 sm:text-lg" data-id="element-118" data-mp="1quxps52zuljw">
          Claim your bundle and all 5 bonuses for just $25.
        </p>

        <p className="mt-8 font-display text-xl font-semibold text-ink sm:mt-9 sm:text-3xl" data-id="element-119" data-mp="1uy2nluc4pz27">
          Stop the chaos. Start the system.
        </p>

        <CtaButton size="lg" className="mt-8 sm:mt-10" data-id="element-120" data-mp="24ufg4ovxu6vd">
          Yes! I want a perfect dog for only $25
        </CtaButton>
      </div>
    </section>;
}